import { FeatureCategory } from '../types';

export const artsCultureFeatures: FeatureCategory = {
  name: "Arts & Culture",
  icon: "Palette",
  features: [
    { 
      name: "Art Institute of Chicago", 
      description: "Virtual access to Art Institute of Chicago collections, exhibitions, and educational content.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Harvard Art Museum",
      description: "Explore Harvard Art Museum's collections and virtual exhibitions from the comfort of your home.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Personal Photo Gallery",
      description: "Create and manage personal photo galleries to preserve and share memories with family and friends.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    }
  ]
};
